import { render, staticRenderFns } from "./SearchCertificatesDialog.vue?vue&type=template&id=a2874bb2&scoped=true"
import script from "./SearchCertificatesDialog.vue?vue&type=script&lang=js"
export * from "./SearchCertificatesDialog.vue?vue&type=script&lang=js"
import style0 from "./SearchCertificatesDialog.vue?vue&type=style&index=0&id=a2874bb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2874bb2",
  null
  
)

export default component.exports